var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcEncrypt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    d: "M12 2c2.21 0 4 1.79 4 4v2h2a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2h2V6c0-2.21 1.79-4 4-4zm6 8H6v10h12V10zm-6 2a2 2 0 012 2 2 2 0 01-1 1.72V18h-2v-2.28A2 2 0 0110 14a2 2 0 012-2zm0-8a2 2 0 00-2 2v2h4V6a2 2 0 00-2-2z"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cg%3E %3Cpath d='M0 0H24V24H0z'/%3E %3Cpath fill='%23231815' d='M12 2c2.21 0 4 1.79 4 4v2h2c1.105 0 2 .895 2 2v10c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V10c0-1.105.895-2 2-2h2V6c0-2.21 1.79-4 4-4zm6 8H6v10h12V10zm-6 2c1.105 0 2 .895 2 2-.004.71-.385 1.365-1 1.72V18h-2v-2.28c-.615-.355-.996-1.01-1-1.72 0-1.105.895-2 2-2zm0-8c-1.105 0-2 .895-2 2v2h4V6c0-1.105-.895-2-2-2z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgIcEncrypt as ReactComponent };